<template>
    <div class="entity-goods-list">
        <div class="item-box" v-for="(item,index) in list" :key="index">
            <entityGoodsItem  :data="item"  @handleClick="handleClick" /> 
        </div>
    </div>
</template>

<script>
import entityGoodsItem from './item.vue'
export default {
    name: 'EntityGoodsList',
    props: {
        list: {
            type: Array,
            default: ()=>[],
        },
    },
    components: {
        entityGoodsItem,
    },
    methods: {
        handleClick(data) {
            this.$emit('handleClick', data)
        },
    },
}
</script>

<style lang="less" scoped>
    .entity-goods-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item-box {
            margin-bottom: 20px;
        }
    }
</style>